import type { Config, Id } from '../config';
import css from './details.module.scss';
import { Header } from './header';
import { Raw } from './raw';
import { Table } from './table';

interface Props {
    section: Config[Id];
    value: string;
    onChange(value: string): void;
    onSelect(id: Id): void;
}
export function Details({ section, value, onChange, onSelect }: Props) {
    const { id, icon, title, text, data } = section;

    if (id === 'raw') return <Raw value={value} icon={icon} onChange={onChange} />;

    return (
        <section className={css.wrapper}>
            <Header icon={icon} title={title} subtitle={text} chip={`${data.size} values`} />
            <Table section={section} onSelect={onSelect} />
        </section>
    );
}
